/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemText } from "./d-theme-dark-menu-item-text";

export class DThemeDarkMenuSidedItemText extends DThemeDarkMenuItemText {}
